<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Enroll Now</h1>
      <ul>
        <li><a class="active" routerLink="/home">Home</a></li>
        <li><a>Alumni</a></li>
        <li>Enroll Now</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 section-layout">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <alumni-menu></alumni-menu>
        </div>

        <div class="col-lg-8">
          <div class="blog-item">
            <div class="blog-content">
              <h3 class="blog-title">Enroll Now</h3>
              <div class="blog-desc management-desc">
                Join PVKK Degree & P.G College and become part of our vibrant academic community. We offer a wide range of undergraduate and postgraduate programs designed to develop complete individuals with knowledge, discipline, and decency. Our experienced faculty and modern infrastructure provide an ideal environment for academic excellence.
              </div>
              <div class="blog-desc management-desc">
                Enrollment is open for eligible candidates interested in pursuing higher education. We welcome applications from students seeking quality education in diverse fields including Engineering, Management, Pharmacy, Education, and Agriculture. Contact our admissions office for detailed information about programs, eligibility criteria, and application procedures.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

